import { TextColor, TextSize } from '@vizit/atoms';
import type { MarkdownTextOptions } from './markdown-text';
import { SpacingDensity } from './types';

/**
 * Default class options for the markdown text
 */
const defaultClassOptions: Required<MarkdownTextOptions> = {
  color: TextColor.Secondary,
  size: TextSize.Md,
  spacing: SpacingDensity.Comfortable,
};

export { defaultClassOptions };
